export const dimensions = [
  { value: 0, label: 'recipient' },
  { value: 1, label: 'page' },
];
